const ADMIN_DOMAIN = "kairo.pm";

export function isSuperuser(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith(`@${ADMIN_DOMAIN}`);
}

export function getAdminDomain() {
  return ADMIN_DOMAIN;
}
